






























































import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import Comments, { ResourceType } from "@/store/modules/Comments";
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import _ from "lodash";

@Component({
    components: {}
})
export default class TagMenu extends Vue {


    @Prop({default: () => [], type: Array})
    selected!: string[];

    @Prop()
    selectedTags!: string[];

    @Prop()
    clearInc!: number

    @Prop({default: ()=>[], type: Array})
    allTags!: string[]

    private newTag = "";
    private innerSelected = []
    private innerTags = []

    mounted() {
        this.innerTags = _.uniq(this.allTags)
        if(this.selectedTags != null) {
            this.innerTags = _.uniq(this.selectedTags.concat(this.allTags))
            this.innerSelected =  this.innerTags.map((tag, index) => {if(this.selectedTags.includes(tag)) return index}).filter(val=> val!= undefined)
        }

    }


    private addTags() {
        this.innerTags.splice(0,0,this.newTag)
        this.innerSelected = this.innerSelected.map(val=> {return(val+1)})
        this.innerSelected.splice(0,0,0)
        this.newTag = ""
    }

    @Watch('innerSelected')
    onChangeInnerSelected() {
        this.$emit('change', this.innerSelected.length > 0 ? this.innerTags.filter((tag, index) => this.innerSelected.includes(index)): null)
    }

    @Watch('clearInc')
    onChangeSelected() {
        this.innerSelected = []
    }

    @Watch('allTags')
    private onChangeAllTags() {
        this.innerTags = _.uniq(this.allTags)
    }
}
